import { PlanSourceType } from '@ebalance/proto/bfftypes/v1/plan_submission_pb'

/**
 * PlanSourceType の日本語ラベルマップ。
 * counterpartyCode / counterpartyName が無い場合（JEPX スポット等）の
 * 列ヘッダ表示フォールバックとして使用する。
 * 文言は i18n（page:procurementPlanDetail.sourceType.*）経由で使うため、
 * この定数は i18n キーのマッピング用。
 *
 * i18n key → Record の構造:
 *   UNSPECIFIED     → 'page:procurementPlanDetail.sourceType.unspecified'
 *   BG_BILATERAL    → 'page:procurementPlanDetail.sourceType.bgBilateral'
 *   E_CLEAR         → 'page:procurementPlanDetail.sourceType.eClear'
 *   JEPX_SPOT       → 'page:procurementPlanDetail.sourceType.jepxSpot'
 *   JEPX_INTRADAY   → 'page:procurementPlanDetail.sourceType.jepxIntraday'
 *   CONSTANT_BACKUP → 'page:procurementPlanDetail.sourceType.constantBackup'
 *   FIT_FIP         → 'page:procurementPlanDetail.sourceType.fitFip'
 *   SELF_WHEELING   → 'page:procurementPlanDetail.sourceType.selfWheeling'
 */
export const PLAN_SOURCE_TYPE_I18N_KEYS: Record<PlanSourceType, string> = {
  [PlanSourceType.UNSPECIFIED]:
    'page:procurementPlanDetail.sourceType.unspecified',
  [PlanSourceType.BG_BILATERAL]:
    'page:procurementPlanDetail.sourceType.bgBilateral',
  [PlanSourceType.E_CLEAR]: 'page:procurementPlanDetail.sourceType.eClear',
  [PlanSourceType.JEPX_SPOT]: 'page:procurementPlanDetail.sourceType.jepxSpot',
  [PlanSourceType.JEPX_INTRADAY]:
    'page:procurementPlanDetail.sourceType.jepxIntraday',
  [PlanSourceType.CONSTANT_BACKUP]:
    'page:procurementPlanDetail.sourceType.constantBackup',
  [PlanSourceType.FIT_FIP]: 'page:procurementPlanDetail.sourceType.fitFip',
  [PlanSourceType.SELF_WHEELING]:
    'page:procurementPlanDetail.sourceType.selfWheeling',
}
